<template>
  <v-container fluid fill-height>
    <v-layout row wrap fill-height>
      <v-flex style="height: 92vh !important">
        <v-snackbar :timeout="snackbar.timeout" bottom right v-model="snackbar.show" color="red accent-2">
          Потеряна связь со службой!
          <v-btn flat color="white" @click.native="snackbar.show = false">Закрыть</v-btn>
        </v-snackbar>
        <v-card class="mx-auto" max-width="400" v-if="showServiceErrorMsg && !preloader">
          <v-card-title class="perron-error">
            Отсутствуют данные по географическим координатам стоянок. Проверьте службу получения данных об объектах
            перрона
          </v-card-title>
        </v-card>
        <v-card class="mx-auto" max-width="400" v-else-if="showDB_ErrorMsg && !preloader">
          <v-card-title class="perron-error"> Отсутствуют данные по географическим координатам стоянок </v-card-title>
        </v-card>
        <v-card class="h-100" v-else>
          <vl-map
            :load-tiles-while-animating="true"
            :load-tiles-while-interacting="true"
            data-projection="EPSG:4326"
            @click.capture="selectObject(0, 0, $event)"
          >
            <!-- <vl-layer-tile id="osm">
              <vl-source-osm></vl-source-osm>
            </vl-layer-tile> -->
            <vl-layer-tile>
              <vl-source-xyz :url="url"></vl-source-xyz>
            </vl-layer-tile>

            <vl-view
              v-if="!preloader"
              :zoom.sync="zoom"
              :min-zoom="Number(13)"
              :max-zoom="Number(19)"
              :center.sync="airportPosition"
            ></vl-view>

            <vl-feature
              :id="'stand-' + index"
              :key="'stand-' + index"
              v-for="(stand, index) in perron">
              <vl-geom-polygon
                :coordinates="[getPolygon(parseFloat(stand.Lng), parseFloat(stand.Lat), geomObjects.stand, 0.00005)]"
              ></vl-geom-polygon>
              <vl-style-box>
                <vl-style-stroke color="red"></vl-style-stroke>
                <vl-style-fill :color="[255, 87, 34, 0.2]"></vl-style-fill>
              </vl-style-box>
            </vl-feature>

            <div v-show="showMap">
              <div v-if="perron.length > 0">
                <vl-feature
                  :id="'plane-' + index"
                  :key="'plane-' + index"
                  v-for="(stand, index) in perron">
                  <vl-overlay
                    style="cursor: pointer;"
                    :style="stand.id_stand == selectStandID ? 'z-index: 99999;' : 'z-index: 1;'"
                    :position="[parseFloat(stand.Lng), parseFloat(stand.Lat)]"
                    @click.native="selectStand(stand.id_stand, index, $event)"
                  >
                    <template v-if="stand.FlightInfo">
                      <div class="overlay-content row">
                        <div class="plane-icon">
                          <img
                            v-if="stand.FlightInfo.IsHell == 1"
                            :width="`${imageWidth}px`"
                            src="/static/img/plane-icons/helicopter.png"
                            alt
                          />
                          <img
                            v-else-if="stand.FlightInfo.MTOW > 130000"
                            :width="`${imageWidth}px`"
                            src="/static/img/plane-icons/large.png"
                            alt
                          />
                          <img
                            v-else-if="stand.FlightInfo.MTOW >= 30000"
                            :width="`${imageWidth}px`"
                            src="/static/img/plane-icons/medium.png"
                            alt
                          />
                          <img
                            v-else
                            :width="`${imageWidth}px`"
                            src="/static/img/plane-icons/small.png"
                            alt
                          />
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="overlay-content row">
                        <div class="plane-icon">
                          {{ stand.Name }}
                        </div>
                      </div>
                    </template>

                  </vl-overlay>
                  <vl-overlay
                    :auto-pan="true"
                    :auto-pan-animation="{ duration: 300 }"
                    :auto-pan-margin="10"
                    :position="[parseFloat(stand.Lng), parseFloat(stand.Lat)]"
                    v-if="selectStandID == stand.id_stand"
                    style="z-index: 99999 !important"
                    :offset="[-5, -30]"
                    positioning="bottom-left"
                  >
                    <bortInfo :bort="stand"></bortInfo>
                  </vl-overlay>
                </vl-feature>
              </div>

              <div v-if="perronObjects.length > 0">
                <vl-feature
                  :id="'obj-' + index"
                  :key="'obj-' + index"
                  v-for="(object, index) in perronObjects">
                  <vl-overlay
                    style="cursor: pointer;"
                    :style="object.Guid == selectObjGUID ? 'z-index: 99999;' : 'z-index: 1;' + 'height: 10px; width: 10px;'"
                    :position="[parseFloat(object.Lng), parseFloat(parseFloat(object.Lat))]"
                    @click.native="selectObject(object.Guid, index, $event)"
                  >
                    <template :slot-scope="scope">
                      <div class="overlay-content row" style="height: 10px; width: 10px">
                        <div class="plane-icon">
                          <div v-if="selectObjGUID == object.Guid">
                            <img :width="`${imageWidth}px`" :src="object.Icon_sel" alt />
                          </div>
                          <div v-else>
                            <img :width="`${imageWidth}px`" :src="object.Icon" alt />
                          </div>
                        </div>
                      </div>
                    </template>
                  </vl-overlay>
                  <vl-overlay
                    :auto-pan="true"
                    :auto-pan-animation="{ duration: 300 }"
                    :auto-pan-margin="10"
                    :position="[parseFloat(object.Lng), parseFloat(parseFloat(object.Lat))]"
                    v-if="selectObjGUID == object.Guid"
                    style="z-index: 99999 !important"
                    :offset="[-5, -30]"
                    positioning="bottom-left"
                  >
                    <objectInfo :object="object"></objectInfo>
                  </vl-overlay>
                </vl-feature>
              </div>

              <div v-if="perronStaff.length > 0">
                <vl-feature
                  :id="'staff-' + index"
                  :key="'staff-' + index"
                  v-for="(staff, index) in perronStaff">
                  <vl-overlay
                    style="cursor: pointer;"
                    :style="staff.Id == selectStaffID ? 'z-index: 99999;' : 'z-index: 1;' + 'height: 10px; width: 10px;'"
                    :position="[parseFloat(staff.Lng), parseFloat(parseFloat(staff.Lat))]"
                    @click.native="selectStaff(staff.Id, index, $event)"
                  >
                    <div class="overlay-content row" style="height: 10px; width: 10px">
                      <div class="plane-icon">
                        <div v-if="selectStaffID == staff.Id">
                          <img :width="`${imageWidth}px`" :src="staff.Icon_sel" alt />
                        </div>
                        <div v-else>
                          <img :width="`${imageWidth}px`" :src="staff.Icon" alt />
                        </div>
                      </div>
                    </div>
                  </vl-overlay>
                  <vl-overlay
                    :auto-pan="true"
                    :auto-pan-animation="{ duration: 300 }"
                    :auto-pan-margin="10"
                    :position="[parseFloat(staff.Lng), parseFloat(parseFloat(staff.Lat))]"
                    v-if="selectStaffID == staff.Id"
                    style="z-index: 99999 !important"
                    :offset="[-5, -30]"
                    positioning="bottom-left"
                  >
                    <staffInfo :staff="staff"></staffInfo>
                  </vl-overlay>
                </vl-feature>
              </div>
            </div>
          </vl-map>
        </v-card>
      </v-flex>
    </v-layout>

    <div class="text-xs-center">
      <v-dialog v-model="preloader" hide-overlay persistent width="300">
        <v-card color="blue" dark>
          <v-card-text>
            Загрузка данных
            <v-progress-linear indeterminate color="white" class="mb-0" height="3"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import store from '@/store'
import geomObjects from '@/geom-objects'
import objectInfo from '../modules/objectInfo'
import staffInfo from '../modules/staffInfo'
import bortInfo from '../modules/bortInfo'
import { eventBus } from '../../eventBus'

export default {
  components: { objectInfo, staffInfo, bortInfo },
  data() {
    return {
      snackbar: {
        show: false,
        timeout: 10000,
      },
      showMap: false,
      showServiceErrorMsg: false,
      showDB_ErrorMsg: false,
      url: 'https://mt.google.com/vt/lyrs=m&hl=ru&x={x}&y={y}&z={z}',
      zoom: 15,
      perronPreloader: true,
      rotation: 0,
      geolocPosition: undefined,
      geomObjects: geomObjects.objects,
      selectObjGUID: 0,
      selectStaffID: 0,
      selectStandID: 0,
      stopTimer: false,
      intervalId: null,
    }
  },
  methods: {
    getPolygon: geomObjects.methods.getPolygon,
    selectObject(guid, index = 0, event = null) {
      this.selectObjGUID = guid
      this.selectStaffID = 0
      this.selectStandID = 0
      if (guid != 0) document.querySelector('#vl-feature-obj-' + index).style.zIndex = 99999
      //if (guid == 0 && index == 0) this.selectStaff(0, 0, event)
    },
    selectStaff(Id, index = 0, event = null) {
      this.selectStaffID = Id
      this.selectObjGUID = 0
      this.selectStandID = 0
      if (Id != 0) document.querySelector('#vl-feature-staff-' + index).style.zIndex = 99999
    },
    selectStand(Id, index = 0, event = null) {
      this.selectStandID = Id
      this.selectStaffID = 0
      this.selectObjGUID = 0
      if (Id != 0) document.querySelector('#vl-feature-stand-' + index).style.zIndex = 99999
    },
    errorMsg() {
      this.showServiceErrorMsg = this.perronObjects.length > 0 ? false :
                                 this.perronStaff.length > 0 ? false :
                                 this.perron.length > 0 ? false : true
    },
    async updateAllPerron() {
      if (!this.stopTimer) {
        await store.dispatch('maps/updatePerronObjectsAll')
        await store.dispatch('maps/updatePerronStaff')
        await store.dispatch('maps/updatePerronStands')
        this.errorMsg()
        setTimeout(this.updateAllPerron, 5000)
      }
    },
    async getData(notLoading) {
      await store.dispatch('maps/updatePerronObjects', {notLoading})
      await store.dispatch('maps/updatePerronObjectsAll')
      await store.dispatch('maps/updatePerronStaff')
      await store.dispatch('maps/updatePerronStands')
    }
  },
  computed: {
    imageWidth: {
      get() {
        switch (this.zoom) {
          case 11:
            return 3
          case 12:
            return 4
          case 13:
            return 5
          case 14:
            return 10
          case 15:
            return 18
          case 17:
            return 30
          case 16:
            return 30
          case 18:
            return 39
          case 19:
            return 42 //145
        }
      },
    },
    airportPosition: {
      get() {
        //return [135.16653833, 48.52853] // Ап Хабаровск
        return store.getters['getAirportPosition']
      },
      set() {},
    },
    perron: {
      get() {
        let perronObjects = store.getters['maps/getPerronStands']
        if (perronObjects.code === '1')
        {
          this.stopTimer = true
          perronObjects = store.getters['maps/getPerronObjects']
          let result = perronObjects.map(function (object) {
            object.Lat = parseFloat(object.LAT_Coord.toString().replace(/,/g, '.'))
            object.Lng = parseFloat(object.LON_Coord.toString().replace(/,/g, '.'))
            return object
          })
          this.showDB_ErrorMsg = result.length == 0 ? true : false
          return result
        }
        else if (perronObjects.code === '2')
        {
          this.snackbar.show = true
          this.showServiceErrorMsg = true
          return []
        }
        else
        {
          let result = perronObjects.map(function (object) {
            object.Lat = parseFloat(object.Lat.toString().replace(/,/g, '.'))
            object.Lng = parseFloat(object.Lng.toString().replace(/,/g, '.'))
            return object
          })
          return result
        }
      },
    },
    perronObjects: {
      get() {
        let perronAllObjects = store.getters['maps/getPerronAllObjects']

        if (perronAllObjects.code === '1')
        {
          clearInterval(this.timerObjID)

          return []
        }
        else if (perronAllObjects.code === '2')
        {
          this.snackbar.show = true
          this.showServiceErrorMsg = true

          return []
        }
        else
        {
          let result = perronAllObjects.map(function (object) {
            object.Lat = parseFloat(object.Lat.toString().replace(/,/g, '.'))
            object.Lng = parseFloat(object.Lng.toString().replace(/,/g, '.'))
            return object
          })

          return result
        }
      },
    },
    perronStaff: {
      get() {
        let perronStaffs = store.getters['maps/getPerronStaff']

        if (perronStaffs.code === '1')
        {
          clearInterval(this.timerStaffID)

          return []
        }
        else if (perronStaffs.code === '2')
        {
          this.snackbar.show = true
          this.showServiceErrorMsg = true

          return []
        }
        else
        {
          let result = perronStaffs.map(function (object) {
            object.Lat = parseFloat(object.Lat.toString().replace(/,/g, '.'))
            object.Lng = parseFloat(object.Lng.toString().replace(/,/g, '.'))
            return object
          })

          return result
        }
      },
    },
    preloader: {
      get() {
        return store.getters['maps/getPerronPreloader']
      },
    },
  },
  async mounted() {
    store.commit('setPageTitle', 'Карта перрона')
    await this.getData()
    this.intervalId = setInterval(() => this.getData(true), 60000)
    this.updateAllPerron()
    eventBus.$on('refresh', async () => {
      await this.getData(true)
    })
  },
  destroyed() {
    this.stopTimer = true
    clearInterval(this.intervalId)
    eventBus.$off('refresh')
  },
}
</script>

<style scoped>
.perron-error {
  font-size: 18px;
}
</style>
